import React from 'react';
import { motion } from 'framer-motion';

const ElasticButton = ({ children, onClick, primary = false }) => {
    return (
        <motion.button
            onClick={onClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{
                type: "spring",
                stiffness: 400,
                damping: 15,
            }}
            className={`
                px-8 py-4 rounded-full font-bold text-lg transition-colors relative overflow-hidden group
                ${primary
                    ? "bg-slate-900 text-white shadow-xl shadow-blue-500/20"
                    : "bg-white text-slate-700 border border-slate-200 hover:bg-slate-50 shadow-sm"
                }
            `}
        >
            {primary && <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-blue-600 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />}
            <span className="relative flex items-center gap-2 z-10">{children}</span>
        </motion.button>
    );
};

export default ElasticButton;
